import { reduxKey } from './constants';
export function getCurrentModal(state) {
    var stack = state[reduxKey];
    if (!stack || !stack.length) {
        return;
    }
    return stack[stack.length - 1];
}
//# sourceMappingURL=selectors.js.map